/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * DPL CMS - REST API
 * The REST API provide by the core REST module.
 * OpenAPI spec version: Versioning not supported
 */

export type CampaignMatchPOST_Format =
  typeof CampaignMatchPOST_Format[keyof typeof CampaignMatchPOST_Format];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampaignMatchPOST_Format = {
  json: "json"
} as const;
